import { Link, Outlet, useLocation } from 'react-router-dom'
import { Header } from './Header'
import { useEffect, useState } from 'react'
import { trackPageView } from '../services/gameAnalytics'
import { SEO } from './SEO'

// The referrer tags installs that started from the website, so they can be told apart in Play Console.
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.zwizle.app&referrer=utm_source%3Dzwizle_web%26utm_medium%3Dfooter'

export const Layout = () => {
  const [isMobile, setIsMobile] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const location = useLocation()

  // Track page views whenever pathname changes
  useEffect(() => {
    try {
      trackPageView(location.pathname)
    } catch (error) {
      console.error('Failed to track page view:', error)
    }
  }, [location.pathname])

  // Check for error messages in location state and handle route changes
  useEffect(() => {
    // Clear any existing error messages when pathname changes
    if (location.pathname !== '/') {
      setErrorMessage(null)
      return
    }

    // Set new error message if present in location state
    if (location.state && location.state.error) {
      setErrorMessage(location.state.error)

      // Clear the error after 5 seconds
      const timer = setTimeout(() => {
        setErrorMessage(null)

        // Clean up location state to prevent error from persisting
        if (window.history.state && window.history.state.state) {
          const newState = { ...window.history.state }
          if (newState.state && newState.state.error) {
            delete newState.state.error
            window.history.replaceState(newState, '')
          }
        }
      }, 5000)

      return () => clearTimeout(timer)
    }
  }, [location.pathname, location.state])

  // Check if viewport is mobile size
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 480)
    }

    // Initial check
    checkIfMobile()

    // Add event listener for resize
    window.addEventListener('resize', checkIfMobile)

    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile)
  }, [])

  return (
    <div className="app-container">
      <SEO />

      <Header />

      {/* Error Alert */}
      {errorMessage && (
        <div className="max-w-lg mx-auto my-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-md shadow-md">
          {errorMessage}
        </div>
      )}

      <main className="main-content">
        <Outlet />
      </main>
      <footer className="app-footer">
        <span>
          {isMobile
            ? `ZWIZLE © ${new Date().getFullYear()}`
            : `ZWIZLE © ${new Date().getFullYear()} | Shona to the everyone`}
        </span>
        {' · '}
        <Link to="/privacy">Privacy Policy</Link>
        {' · '}
        <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
          {isMobile ? 'Get the app' : 'Get the Android app'}
        </a>
      </footer>
    </div>
  )
}
